import FiveStarRating from './Stars5';
import FourStarRating from './Stars4';
import ThreeStarRating from './Stars3';
import TwoStarRating from './Stars2';
import OneStarRating from './Stars1';
import ZeroStarRating from './Stars0';

function getStyleForSize(size) {
    switch (size) {
        case 'footer':
            return { width: 91, height: 22, position: 'relative', top: '5px' };
        case 'small':
            return { width: 91, height: 22 };
        case 'medium':
            return { width: 133, height: 29 };
        case 'large':
            return { width: 177, height: 38 };
        case 'xl':
            return { width: 266, height: 58 };
        default:
            return { width: 133, height: 29 };
    }
}

export default function StarRating({ value = 0, size = 'medium', style }) {
    const merged = { ...getStyleForSize(size), ...(style || {}) };

    switch (value) {
        case 0:
            return <ZeroStarRating style={merged} />;
        case 1:
            return <OneStarRating style={merged} />;
        case 2:
            return <TwoStarRating style={merged} />;
        case 3:
            return <ThreeStarRating style={merged} />;
        case 4:
            return <FourStarRating style={merged} />;
        case 5:
            return <FiveStarRating style={merged} />;
        default:
            return <ZeroStarRating style={merged} />;
    }
}
